import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { rgba } from 'polished';
import SelectStyles from '@stories/Components/Forms/Select/Select.styles';
import styled from 'styled-components';
import DatePickerStyles from '@stories/Components/Forms/DatePicker/DatePicker.styles';
import FormFieldStyles from '@stories/Components/Forms/FormField/FormField.styles';
const Container = styled.div `
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr;

  @media ${from(Device.Desktop)} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 40px;
    margin-bottom: 50px;
  }

  @media ${from(Device.DesktopLarge)} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  ${DatePickerStyles.Wrapper} {
    max-width: 100%;

    .rdrCalendarWrapper {
      width: 100%;
      background: none;
    }

    .rdrMonthAndYearWrapper,
    .rdrMonthsVertical {
      background: ${brand.white};
    }

    .rdrDateDisplayItem {
      border-color: ${rgba(brand.grey.grey55, 0.75)};
      background: ${brand.white};
    }

    .rdrDateDisplayItemActive {
      border-color: ${brand.primary.base};
    }

    .rdrDateDisplayItem input {
      height: 48px;
      font-size: 16px;
      ${fonts.DaxPro['Regular']};
      padding: 0 36px 0 18px;
    }
    .rdrDateInput:after {
      right: 15px;
      width: 17px;
      opacity: 0.5;
    }

    .rdrMonthAndYearWrapper {
      padding-top: 0;
    }

    .rdrDateDisplayItem + .rdrDateDisplayItem {
      margin-left: 12px;

      @media ${from(Device.TabletLarge)} {
        margin-left: 40px;
      }
    }
  }

  ${DatePickerStyles.LabelText} {
    grid-gap: 12px;

    @media ${from(Device.TabletLarge)} {
      grid-gap: 40px;
    }
  }

  ${FormFieldStyles.Element} {
    position: relative;
  }
`;
const Item = styled.div `
  ${SelectStyles.Element} {
    background-color: ${brand.white};
    width: 100%;
    border-color: ${rgba(brand.grey.grey55, 0.75)};
  }

  ${SelectStyles.Item}:nth-child(1) {
    opacity: 1;
    pointer-events: all;

    &:hover {
      background-color: ${brand.primary.base};
      color: ${brand.white};
    }
  }
`;
const SearchButton = styled.div `
  position: absolute;
  display: inline-flex;
  align-items: center;
  top: 0;
  right: 18px;
  height: 100%;
  width: 27px;
  cursor: pointer;

  svg {
    width: 27px;
    height: 27px;
    color: ${brand.grey.grey55};
  }
`;
const Label = styled.div `
  font-size: 18px;
  ${fonts.DaxPro['Medium']};
  color: ${brand.black};
  margin-bottom: 6px;
`;
export default {
    Container,
    Item,
    Label,
    SearchButton,
};
